<template lang="html">
  <div>
    <br>
    <v-layout align-center justify-center>
      <v-flex xs12 lg8>

        <!-- Dialog informando que a ação de extensão não possui alunos de graduação e de pós-graduação cadastrados na aba Equipe -->
        <c-confirm-dialog-alunos v-model="dialogAusenciaAlunos" @yes="redirecionaAbaEquipe()" titulo="Ausência de alunos de graduação e/ou pós-graduação na equipe">
          A ação de extensão ainda não possui estudantes de graduação e/ou pós-graduação cadastrados, o que é necessário para que a ação possa ser atualizada no sistema. Realize o cadastro na aba EQUIPE.
        </c-confirm-dialog-alunos>

        <!-- Mensagem informativa sobre ações de extensão que possuem períodos de suspensão -->
        <v-layout row wrap text-xs-left v-if="(this.administrador === true || this.usuarioPROEX === true) && this.projeto.suspensoes === true">
          <v-flex xs12>
            <v-alert
              class="alertaSuspensao"
              dense
              type="info"
              color="#00796b"
              outlined
            >
              Esta ação possui períodos de suspensão cadastrados, para maiores detalhes verificar a aba EXTENSÃO.
            </v-alert>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs12>
            <c-readonly-field label="Título" :value="this.projeto.titulo"></c-readonly-field>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs6>
            <c-readonly-field label="Número" :value="this.projeto.idProjeto"></c-readonly-field>
          </v-flex>
          <v-flex xs6>
            <c-readonly-field label="Situação" :value="this.projeto.situacao.descricao"></c-readonly-field>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs6>
            <c-readonly-field label="Tipo de público-alvo" :value="this.projeto.tipoPublico.descricao"></c-readonly-field>
          </v-flex>
          <v-flex xs6>
            <c-readonly-field label="Público-alvo estimado" :value="this.projeto.publicoAlvo || ' '"></c-readonly-field>
          </v-flex>
        </v-layout>

        <v-layout row v-if="projeto.classificacaoSecundaria.id === 39729">
          <v-flex xs6>
            <c-readonly-field label='Carga horária do curso' :value="this.projeto.cargaHoraria || ' '"></c-readonly-field>
          </v-flex>
        </v-layout>

        <v-layout row v-if="projeto.classificacaoSecundaria.id === 44194">
          <v-flex xs6>
            <c-readonly-field label='Carga horária do curso' :value="this.projeto.cargaHoraria || ' '"></c-readonly-field>
          </v-flex>
        </v-layout>

        <v-layout row v-if="projeto.classificacaoSecundaria.id === 44195">
          <v-flex xs6>
            <c-readonly-field label='Carga horária da oficina' :value="this.projeto.cargaHoraria || ' '"></c-readonly-field>
          </v-flex>
        </v-layout>

        <v-layout row v-if="projeto.classificacaoSecundaria.id === 39730">
          <v-flex xs6>
            <c-readonly-field label='Carga horária do evento' :value="this.projeto.cargaHoraria || ' '"></c-readonly-field>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs6>
            <c-readonly-field label="Data de início" :value="this.projeto.dataInicio"></c-readonly-field>
          </v-flex>
          <v-flex xs6>
            <c-readonly-field label="Data de conclusão" :value="this.projeto.dataConclusao"></c-readonly-field>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs3>
            <c-readonly-field label="Palavra-chave 1" :value="this.projeto.palavraChave01 || ' '"></c-readonly-field>
          </v-flex>
          <v-flex xs3>
            <c-readonly-field label="Palavra-chave 2" :value="this.projeto.palavraChave02 || ' '"></c-readonly-field>
          </v-flex>
          <v-flex xs3>
            <c-readonly-field label="Palavra-chave 3" :value="this.projeto.palavraChave03 || ' '"></c-readonly-field>
          </v-flex>
          <v-flex xs3>
            <c-readonly-field label="Palavra-chave 4" :value="this.projeto.palavraChave04 || ' '"></c-readonly-field>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs12>
            <c-readonly-field label="Resumo" :value="this.projeto.resumo" align="justify"></c-readonly-field>
          </v-flex>
        </v-layout>

      </v-flex>
    </v-layout>

    <c-card-footer
      :projeto="this.projeto"
      :extensao="this.extensao"
      proxima="ClassificacoesProjeto"
      :editar="this.permissaoEditar(this.projeto.situacao.item) ? 'EditarInformacoes' : null"
      nome_editar="Editar"
      :habilitaBotaoGerarPDFAcao=true
      :habilitaBotaoFinalizarAcao=true
    >
    </c-card-footer>

  </div>
</template>

<script>
import CardFooter from '@/components/c-card-footer'
import ConfirmDialogAlunos from '@/components/c-confirm-dialog-alunos'
import ReadonlyField from '@/components/c-readonly-field'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import dates from '@/utils/dates'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjeto', 'projeto', 'extensao'],
  data: () => ({
    dates: dates,
    dialogAusenciaAlunos: false,
    formularioValido: false,
    observacoesRules: [
      (input) => !!input || 'Este campo é obrigatório',
      (input) => !!input && input.length <= 60 || 'Este campo não pode possuir mais que 60 caracteres'
    ]
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'usuarioPROEX'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    permissaoEditar: function (situacaoAcaoExtensao) {
      // Coordenador ou assessor
      if ((this.usuarioCoordenador() || this.usuarioAssessor()) && situacaoAcaoExtensao === 15) {
        return true
      } else if (this.usuarioAdministrador() && [3, 4, 15, 16, 18, 19, 20, 22].includes(situacaoAcaoExtensao)) { // Administrador - inclusao da situacao 'Inadimplente' (3)
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão está na situação "Ativo".
    situacaoAtivo: function () {
      if (this.projeto.situacao.item === 18) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão está na situação "Aguardando relatório".
    situacaoAguardandoRelatorio: function () {
      if (this.projeto.situacao.item === 20) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado é o coordenador da ação de extensão.
    usuarioCoordenador: function () {
      if ((this.projeto.funcao != null && this.projeto.funcao.item === 1)) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado é assessor da ação de extensão.
    usuarioAssessor: function () {
      if (this.projeto.assessor === true) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado é administrador.
    usuarioAdministrador: function () {
      if (this.administrador === true) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão possui alunos de graduação ou pós-graduação cadastrados.
    acaoExtensaoNaoPossuiAlunosCadastrados: function () {
      if (this.projeto.possuiAlunos === false) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação deve ser redirecionada para a aba EQUIPE.
    verificaSeAcaoDeveSerRedirecionadaParaAbaEquipe: function () {
      if (this.situacaoAtivo() || this.situacaoAguardandoRelatorio()) {
        if (this.usuarioCoordenador() || this.usuarioAssessor()) {
          if (this.acaoExtensaoNaoPossuiAlunosCadastrados()) {
            return true
          }
        }
      } else {
        return false
      }
    },
    // Redireciona para a aba EQUIPE.
    redirecionaAbaEquipe: function () {
      this.$router.push({name: 'IntegrantesProjeto', params: {idProjeto: this.idProjeto}})
    }
  },
  mounted () {
    if (this.verificaSeAcaoDeveSerRedirecionadaParaAbaEquipe() && this.projeto.idProjeto !== 2785) { // Tarefa #13468.
      this.dialogAusenciaAlunos = true
    }
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-confirm-dialog-alunos': ConfirmDialogAlunos,
    'c-card-footer': CardFooter,
    'c-readonly-field': ReadonlyField
  }
}
</script>

<style lang="css" scoped>

  .alertaSuspensao {
    margin: 0.25em 0 1.5em 0;
    font-size: 1.10em
  }

</style>





// WEBPACK FOOTER //
// projeto-formulario.vue?763501f6